import type { ButtonHTMLAttributes, JSX } from 'react';
import { forwardRef } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
}

/** Forwards its ref so a caller can return focus to it (a row's Edit button after Save). */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', loading = false, disabled, className, children, ...rest },
  ref,
): JSX.Element {
  const classes = ['ds-button', `ds-button--${variant}`, `ds-button--${size}`];
  if (loading) classes.push('is-loading');
  if (className !== undefined) classes.push(className);
  return (
    <button
      ref={ref}
      type="button"
      className={classes.join(' ')}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="ds-button__spinner" aria-hidden="true" /> : null}
      <span className="ds-button__label">{children}</span>
    </button>
  );
});
